/* src/components/Products/Products.jsx */
import './Products.css'
import { Button, HandButton } from "../Button/Button.jsx";
import { usePanelStatus } from "../HorizontalScroll/panelStatus.js";

const PRODUCTS = [
	{
		id: 'stare-misto',
		img: '/images/stare-misto.webp',
		title: 'Старе місто',
		text: 'Класика з багатою палітрою кольорів',
		url: 'https://shop.kovalska.com/old-town/',
	},
	{
		id: 'laynston',
		img: '/images/laynston.webp',
		title: 'Лайнстоун',
		text: 'Правильна геометрія та міць',
		url: 'https://shop.kovalska.com/linestone/',
	},
	{
		id: 'lotok',
		img: '/images/lotok.webp',
		title: 'Лоток водовідвідний',
		text: 'Важлива деталь системи дренажу',
		url: 'https://shop.kovalska.com/drainage-tray/',
	},
	{
		id: 'bordyur',
		img: '/images/bor.webp',
		title: 'Бордюр',
		text: 'Міцна опора',
		url: 'https://shop.kovalska.com/park-curb/',
	},
];

// статус панелі з контексту → клас-фаза інтро
const STATUS_CLASS = {
	after: 'is-armed',   // ще не дійшли: сховано, прямокутник накриває
	active: 'is-in',     // доведена: прямокутник іде, заголовок і картки виїжджають
	before: 'is-out',    // пройшли далі: заголовок угору, картки заливаються --accent
	static: null,        // без горизонтального скролу: просто показуємо контент
};

const Products = () => {
	const status = usePanelStatus();
	const classes = ['products', STATUS_CLASS[status]].filter(Boolean).join(' ');

	return (
		<section className={classes} id="collections">
			<div className="products__intro" aria-hidden="true" />

			<h3 className="products__title">Оберіть для себе</h3>
			<ul className="products__list">
				{PRODUCTS.map((p, i) => (
					<li className="products__list-item" key={p.id} style={{ '--i': i }}>
						<span className="products__fill" aria-hidden="true" />

						<div className="products__item-container">
							<div className="products__item-inner">
								<div className="products__reveal">
									<img src={p.img} alt={p.title} />
									<div className="products__item-txt">
										<h4>{p.title}</h4>
										<span>{p.text}</span>

										<HandButton
											className="products__item-tap"
											href={p.url}
											aria-label={`Детальніше: ${p.title}`}
											analyticsEvent="cta_click"
											analyticsParams={{ location: 'products', label: p.id }}
										/>
									</div>
								</div>

								<Button
									variant="primary"
									size="sm"
									as="a"
									href={p.url}
									target="_blank"
									rel="noopener noreferrer"
									analyticsEvent="cta_click"
									analyticsParams={{ location: "products", label: p.id }}
									className="products__item-btn"
								>
									Детальніше
								</Button>
							</div>
						</div>
					</li>
				))}
			</ul>
		</section>
	);
};

export default Products;